import SimpleModal from "./SimpleModal";
export default SimpleModal;
